module.exports = __webpack_public_path__ + "static/media/pro_pechi.ee75ce3a.pdf";